import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../services/base-service.service';
import { ProcessoMovimento } from './processo-movimento.model';
import { ConsultaPaginada, ConsultaPaginadaResultado } from 'maestro-ng';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class ProcessoMovimentoService extends BaseService<ProcessoMovimento, number> {
  constructor(http: HttpClient) {
    super('processoMovimento', http);
  }

  public recuperarPorProcessoId(processoId: number): Promise<ProcessoMovimento[]> {
    return firstValueFrom(this.http.get<ProcessoMovimento[]>(this.path(`recuperarPorProcessoId/${processoId}`)));
  }

  public recuperarPaginadoPorProcesso(
    processoId: number,
    consulta: ConsultaPaginada
  ): Promise<ConsultaPaginadaResultado<ProcessoMovimento>> {
    return firstValueFrom(
      this.http.post<ConsultaPaginadaResultado<ProcessoMovimento>>(
        this.path(`recuperarPaginadoPorProcessoId/${processoId}`),
        consulta,
        { headers: this.createJsonHttpHeaders() }
      )
    );
  }
}
